import { makeAssistantToolUI } from '@assistant-ui/react'
import { useMemo } from 'react'
import { ReadUserGuidePageView } from '@/components/agent/tools/ReadUserGuidePageView'
import type { ToolRunStatus } from './parse-tool-result'
import {
  parseReadResult,
  type ReadUserGuidePageArgs,
  type ReadUserGuidePageResult,
} from './user-guide'

interface RenderProps {
  args: ReadUserGuidePageArgs
  result?: ReadUserGuidePageResult | string
  status: ToolRunStatus
}

/** Connected `read_user_guide_page` card: parses the payload and renders the view. */
function ReadUserGuidePageRender({ args, result, status }: RenderProps) {
  const parsed = useMemo(() => parseReadResult(result), [result])
  return (
    <ReadUserGuidePageView
      args={args}
      parsed={parsed}
      running={status.type === 'running'}
      errored={status.type === 'incomplete'}
    />
  )
}

export const ReadUserGuidePageToolUI = makeAssistantToolUI<
  ReadUserGuidePageArgs,
  ReadUserGuidePageResult | string
>({
  toolName: 'read_user_guide_page',
  render: ReadUserGuidePageRender,
})
